export class NavigatorWithQS {
  history=null;
  location=null;
  instance=null;
  path=null
  constructor(history, location) {
    if (this.instance) {
      return this.instance
    }
    this.history = history
    this.location = location
  }

  static getInstance(history, location) {
    if (this.instance == null) {
      this.instance = new NavigatorWithQS(history, location)
    }
    return this.instance
  }

  push(path) {
    this.path = path + this.location.search
    this.history.push(this.path)
  }

  replace(path) {
    this.path = path + this.location.search
    this.history.replace(this.path)
  }

  back(path) {
    this.history.goBack(this.path)
  }
}
